export function getInstructionsTextToExport({
  projectInstructions,
  chaptersInstructions
}: {
  projectInstructions: string;
  chaptersInstructions: Record<string, string>;
}) {
  const textToExport = `
PROJECT INSTRUCTIONS:
${projectInstructions}

--------------------------------

${Object.entries(chaptersInstructions)
  .map(([key, value]) => (value ? `${key}\n${value}` : `${key} - No instructions`))
  .join("\n\n--------------------------------\n\n")}
`;
  return textToExport;
}
